import {
  i18n as AdpMassFlowMeterChartI18n,
  ADP_MASS_FLOW_METER_CHART_NS,
} from '../components/AdpMassFlowMeter/AdpMassFlowMeterChart/i18n';
import { i18n as LiveSession18n, LIVE_SESSION_NS } from '../components/BunkeringDashboard/i18n';
import { i18n as ResetButton18n, RESET_BUTTON_NS } from '../components/Buttons/i18n';
import { i18n as MFMComparison18n, MFM_COMPARISON_NS } from '../components/MFMComparison/i18n';
import { i18n as Navigation18n, NAVIGATION_NS } from './navigation';
import { i18n as Routes18n, ROUTES_NS } from '../routes/i18n';
import { i18n as RightDrawer18n, RIGHT_DRAWER_NS } from '../components/RightDrawer/i18n';
import {
  i18n as HorizontalScale18n,
  HORIZONTAL_SCALE_NS,
} from '../components/HorizontalScale/i18n';
import { i18n as Aggregators18n, AGGREGATORS_NS } from '../components/Aggregators/i18n';
import { i18n as DataGrid18n, DATA_GRID_DL_NS } from '../components/DataGrid/i18n';
import { i18n as NoDataDisplayi18n, NO_DATA_DISPLAY_NS } from '../components/NoDataDisplay/i18n';
import { i18n as AlarmLogsi18n, ALARM_LOGS_NS } from '../components/AlarmLogs/i18n';
import { i18n as BunkeringLogsi18n, BUNKERING_LOGS_NS } from '../components/BunkeringLogs/i18n';
import { i18n as Modalsi18n, MODALS_NS } from '../components/Modals/i18n';
import { i18n as ErrorBanneri18n, ERROR_BANNER_NS } from '../components/StreamErrorBanner/i18n';
import { Navigationi18n, Navigation } from '../components/Navigation/i18n';
import { Settingsi18n, Settings } from '../components/Settings/i18n';

export const resources = {
  en: {
    [ADP_MASS_FLOW_METER_CHART_NS]: AdpMassFlowMeterChartI18n.en,
    [LIVE_SESSION_NS]: LiveSession18n.en,
    [RESET_BUTTON_NS]: ResetButton18n.en,
    [MFM_COMPARISON_NS]: MFMComparison18n.en,
    [NAVIGATION_NS]: Navigation18n.en,
    [ROUTES_NS]: Routes18n.en,
    [RIGHT_DRAWER_NS]: RightDrawer18n.en,
    [HORIZONTAL_SCALE_NS]: HorizontalScale18n.en,
    [AGGREGATORS_NS]: Aggregators18n.en,
    [DATA_GRID_DL_NS]: DataGrid18n.en,
    [NO_DATA_DISPLAY_NS]: NoDataDisplayi18n.en,
    [ALARM_LOGS_NS]: AlarmLogsi18n.en,
    [BUNKERING_LOGS_NS]: BunkeringLogsi18n.en,
    [MODALS_NS]: Modalsi18n.en,
    [ERROR_BANNER_NS]: ErrorBanneri18n.en,
    [Navigation]: Navigationi18n.en,
    [Settings]: Settingsi18n.en,
  },
};
